import * as angular from 'angular';
import CoreModule from './../core/core.module';
import SharedModule from './../shared/shared.module';
import CommunicationToolService from './communication-tool.service';
import communicationToolListComponent from './communication-tool-list/communication-tool-list.component';
import communicationToolCollectionComponent from './communication-tool-collection/communication-tool-collection.component';
import communicationToolDetailComponent from './communication-tool-detail/communication-tool-detail.component';
import communicationToolFilterComponent from './communication-tool-filter/communication-tool-filter.component';
import { CommunicationToolItem, CommunicationToolCollection, CommunicationToolCategory } from './communication-tool.model';
import communicationToolRoutes from './communication-tool.routes';

export default angular
  .module('CommunicationToolModule', [
    CoreModule,
    SharedModule,
  ])
  .config((RouterServiceProvider) => {
    RouterServiceProvider.configureStates(communicationToolRoutes);
  })
  .service('CommunicationToolService', CommunicationToolService)
  .component('communicationToolList', communicationToolListComponent)
  .component('communicationToolCollection', communicationToolCollectionComponent)
  .component('communicationToolDetail', communicationToolDetailComponent)
  .component('communicationToolFilter', communicationToolFilterComponent)
  .value('CommunicationToolItem', CommunicationToolItem)
  .value('CommunicationToolCollection', CommunicationToolCollection)
  .value('CommunicationToolCategory', CommunicationToolCategory)
  .name;



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool.module.js